import React, { useEffect } from "react";
import { OneTapLoginConstants } from "../../../constants/keys/googleOneTapLogin";
import { checkCartAndLoginCookie } from "../../../utils/fus";
import { SOCIAL_LOGIN_KEY } from "../../../analytics/gaConstant";
import { setSessionStorage } from "../../../utils/storage/sessionStorageUtil";
import { getGoogleResponseCall } from "../../../api/loginApi";

/**
 * This functional component provides the functionality of Google One Tap Login
 *
 * @returns {React.ReactElement} It returns nothing.
 */
const OneTapLogin = () => {
  /**
   * @function handleCredentialResponse - This is the callback function from the initialization.
   * @param {*} res - The response containing the credential from Google One Tap.
   */
  const handleCredentialResponse = async (res) => {
    if (res.credential) {
      setSessionStorage(SOCIAL_LOGIN_KEY, true);

      await getGoogleResponseCall(res.credential);
      if (typeof window?.clearAndDestoryWidget === "function") {
        window?.clearAndDestoryWidget();
      }
      window.location.reload();
    }
  };

  useEffect(() => {
    if (!checkCartAndLoginCookie()) {
      // Initialize Google One Tap
      if (window.google && window.google.accounts && window.google.accounts.id) {
        window.google.accounts.id.initialize({
          client_id: OneTapLoginConstants.CLIENT_ID,
          callback: handleCredentialResponse,
          cancel_on_tap_outside: false,
        });
        window.google.accounts.id.prompt();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default OneTapLogin;
